/*@flow*/

export default function isString(x: any): %checks {
  return typeof x === 'string';
}
